import { ShieldCheck, Camera, Clock, Heart, Headphones } from "lucide-react";

const guaranteesRu = [
  { icon: ShieldCheck, title: "Гарантия свежести", text: "Цветы срезаны не более 48 часов назад. Если букет завял в первый день — заменим бесплатно." },
  { icon: Camera, title: "Фото до доставки", text: "Присылаем фото готового букета в WhatsApp перед отправкой. Никаких сюрпризов." },
  { icon: Clock, title: "Точно в срок", text: "Доставим в указанное время. Если опоздали — доставка за наш счёт." },
  { icon: Heart, title: "Индивидуальный подход", text: "Учтём все пожелания: цвет, размер, аллергии получателя, текст открытки." },
  { icon: Headphones, title: "Поддержка 24/7", text: "Отвечаем в WhatsApp и Telegram на русском и английском. Всегда на связи." },
];

const guaranteesEn = [
  { icon: ShieldCheck, title: "Freshness Guarantee", text: "Flowers cut no more than 48 hours ago. If the bouquet wilts on day one — free replacement." },
  { icon: Camera, title: "Photo Before Delivery", text: "We send a photo of the finished bouquet via WhatsApp before dispatch. No surprises." },
  { icon: Clock, title: "On-Time Delivery", text: "We deliver at the specified time. If we're late — delivery is on us." },
  { icon: Heart, title: "Personal Touch", text: "We consider all wishes: color, size, recipient allergies, card text." },
  { icon: Headphones, title: "24/7 Support", text: "We respond on WhatsApp and Telegram in Russian and English. Always available." },
];

const guaranteesTr = [
  { icon: ShieldCheck, title: "Tazelik garantisi", text: "Çiçekler en fazla 48 saat önce kesilmiştir. İlk gün solarsa — ücretsiz değişim." },
  { icon: Camera, title: "Teslimat öncesi fotoğraf", text: "Hazır buketin fotoğrafını WhatsApp ile göndeririz. Sürpriz yok." },
  { icon: Clock, title: "Zamanında teslimat", text: "Belirtilen saatte teslim ederiz. Gecikirsek — teslimat bizden." },
  { icon: Heart, title: "Kişiye özel yaklaşım", text: "Tüm isteklerinizi dikkate alırız: renk, boyut, alıcının alerjileri, kart mesajı." },
  { icon: Headphones, title: "7/24 destek", text: "WhatsApp ve Telegram'da Rusça ve İngilizce yanıt veriyoruz. Her zaman ulaşılabilir." },
];

export const GuaranteesSection = ({ lang = "ru" }) => {
  const items = lang === "tr" ? guaranteesTr : (lang === "en" ? guaranteesEn : guaranteesRu);
  const titleMain = lang === "tr" ? "Garantilerimiz" : (lang === "en" ? "Our" : "Наши");
  const titleAccent = lang === "tr" ? "" : (lang === "en" ? "guarantees" : "гарантии");

  return (
    <section className="py-12 sm:py-16 bg-white" data-testid="guarantees-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-8 sm:mb-12">
          <h2
            className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-3"
            style={{ fontFamily: "Playfair Display, serif" }}
          >
            {titleMain}{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-rose-500">
              {titleAccent}
            </span>
          </h2>
          <p className="text-gray-500 text-sm sm:text-base max-w-lg mx-auto">
            {lang === "tr"
              ? "Buketlerimizin ve hizmetimizin kalitesinden eminiz"
              : lang === "en"
              ? "We are confident in the quality of our bouquets and service"
              : "Мы уверены в качестве наших букетов и сервиса"}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          {items.map((item, i) => {
            const Icon = item.icon;
            return (
              <div
                key={i}
                className="flex gap-4 p-4 sm:p-5 rounded-2xl border border-gray-100 hover:border-pink-200 hover:shadow-md transition-all group"
                data-testid={`guarantee-${i}`}
              >
                <div className="w-10 h-10 rounded-xl bg-pink-50 group-hover:bg-pink-100 flex items-center justify-center flex-shrink-0 transition-colors">
                  <Icon className="w-5 h-5 text-pink-500" />
                </div>
                <div>
                  <h3 className="text-sm font-bold text-gray-900 mb-1">{item.title}</h3>
                  <p className="text-xs sm:text-sm text-gray-500 leading-relaxed">{item.text}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default GuaranteesSection;
